import { useQuery } from 'react-query';
import { ImageType, IOrderRow } from '../../../Entities';
import ImageProcessingApi from '../../../api/ImageProcessingApi';
import { getUserInfo } from '../../../../../../../telemetry/utils';
import { AuthenticatedUser } from '../../../../../../../shared/types';
import { useTelemetryContext } from '../../../../../../../telemetry/telemetryContext';

type ImagesQueryArgs = {
    orderId: number;
    imageType: ImageType;
    user: AuthenticatedUser;
    enabled?: boolean;
};

export const PROCESSING_POLL_INTERVAL_MILLISECONDS = 1500;

export let imagesQueryKey = 'image-editor-image-processing-page-get-images';

export function isProcessingImages(orderRows: IOrderRow[]): boolean {
    return orderRows.some(
        (orderRow) =>
            orderRow.uploadsInProgress.length > 0 ||
            orderRow.editedPhotosUploadInProgress === true ||
            orderRow.thumbnails.some((thumbnail) => !thumbnail.reference)
    );
}

export function useImagesQuery({ orderId, imageType, user, enabled = true }: ImagesQueryArgs) {
    let { logger } = useTelemetryContext();

    let { data, isLoading, dataUpdatedAt } = useQuery<IOrderRow[]>(
        [imagesQueryKey, { orderId, imageType }],
        () => ImageProcessingApi.listImages(orderId, imageType),
        {
            useErrorBoundary: true,
            enabled,
            refetchInterval: (orderRows) =>
                orderRows && isProcessingImages(orderRows)
                    ? PROCESSING_POLL_INTERVAL_MILLISECONDS
                    : false,
            onError: (error) => {
                let additionalInfo = {
                    origin: 'ImageEditorImageProcessingPage.Query.getImages',
                    userInfo: getUserInfo(user),
                    imageType
                };
                logger.logException(error, additionalInfo);
            }
        }
    );

    return { data: data != null ? data : null, isLoading, dataUpdatedAt };
}
